var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromoBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telegram\u5907\u4EFD 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-13\\u5907\\u4EFD",
    transform: "translate(-61.000000, -626.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram\\u5907\\u4EFD-9",
    transform: "translate(61.000000, 626.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#CB3A2F",
    x: 14,
    y: 14,
    width: 56,
    height: 56,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#FFFFFF",
    strokeWidth: 5.25,
    cx: 42,
    cy: 35,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,59.5 C56,51.7680135 49.7319865,45.5 42,45.5 C34.2680135,45.5 28,51.7680135 28,59.5",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeWidth: 5.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoBonus);
export default __webpack_public_path__ + "static/media/promo_bonus.bb669bc92aa6eb9bee0abc2e48805fba.svg";
export { ForwardRef as ReactComponent };